import React, {  ChangeEventHandler, ChangeEvent, useState } from 'react'
import './Switch.scss'

const Switch = ({
  onChange,
  labelOn,
  labelOff,
  isChecked,
  isDisabled,
  key
}) => {
  const [isCheckedLocal, setCheckedLocal] = useState(isChecked)
  const handleChange = ()  => {
    if (isDisabled) {
      return
    }
    onChange(event)
    setCheckedLocal(!isCheckedLocal)
  }
  return (
    <div className="switch-wrapper">
      <label className="switch-wrapper__label" htmlFor={key}>
        <input
          type="checkbox"
          id={key}
          disabled={isDisabled}
          className="switch-wrapper__label__hidden-control"
          onChange={handleChange}
        />
        <span className="switch-wrapper__label__text">{labelOff}</span>
        <div
          className={`switch-wrapper__label__switch ${
            isCheckedLocal
              ? 'switch-wrapper__label__switch--checked'
              : 'switch-wrapper__label__switch--unchecked'
          }
          ${isDisabled ? 'switch-wrapper__label__switch--disabled' : ''}`}
        />
        <span className="switch-wrapper__label__text">{labelOn}</span>
      </label>
    </div>
  )
}

export default Switch;
